export default __webpack_public_path__ + "static/team-jacob-58f38b94c7af137a1fc7b1b99dbfa1b1.jpg";